import { ColorUtilities } from "./ColorUtilities";

export class UIStyleConstants {
    static PRIMARY_COLOR = "#b39c49";

    static BLUE_COLOR = UIStyleConstants.PRIMARY_COLOR;
    static BLUE_LIGHT_COLOR = UIStyleConstants.PRIMARY_COLOR;
    static BLUE_LIGHTER_COLOR = UIStyleConstants.PRIMARY_COLOR;
    static BLUE_VERY_LIGHT_COLOR = UIStyleConstants.PRIMARY_COLOR;
    static BLUE_GRAY_COLOR = UIStyleConstants.PRIMARY_COLOR;

    static GRAY_DARK_COLOR = "#555D76";
    static GRAY_COLOR = "#7B7B80";
    static GRAY_LIGHTER_COLOR = "#C6C6C9";
    static GRAY_LIGHT_COLOR = "#E6E6EC";
    static GRAY_VERY_LIGHT_COLOR = "#EFEFF5";

    static RED_DARK_COLOR = "#CA3948";
    static RED_COLOR = "#EC364A";
    static RED_LIGHT_COLOR = "#EF8B96";
    static RED_VERY_LIGHT_COLOR = "#E7D0D3";

    static YELLOW_DARK_COLOR = "#E1A923";
    static YELLOW_COLOR = "#F2C655";
    static YELLOW_LIGHT_COLOR = "#EFD899";
    static YELLOW_VERY_LIGHT_COLOR = "#F8ECCE";

    static ORANGE_DARK_COLOR = "#B96A41";
    static ORANGE_COLOR = "#F28A55";
    static ORANGE_LIGHT_COLOR = "#EEAF8F";
    static ORANGE_VERY_LIGHT_COLOR = "#F3D0C8";

    static PURPLE_DARK_COLOR = UIStyleConstants.PRIMARY_COLOR;
    static PURPLE_COLOR = UIStyleConstants.PRIMARY_COLOR;
    static PURPLE_LIGHT_COLOR = UIStyleConstants.PRIMARY_COLOR;
    static PURPLE_VERY_LIGHT_COLOR = UIStyleConstants.PRIMARY_COLOR;

    static GREEN_DARK_COLOR = "#116041";
    static GREEN_COLOR = "#2FAD7C";
    static GREEN_LIGHTER_COLOR = "#55C48C";
    static GREEN_LIGHT_COLOR = "#AEDAC2";
    static GREEN_VERY_LIGHT_COLOR = "#D9E3D9";

    static WHITE_DARK_COLOR = "#F0F0F0";
    static WHITE_SEMI_DARK_COLOR = "#F7F8FC";
    static WHITE_COLOR = "white";

    static BLACK_COLOR = "#23252C";

    static FONT_FAMILY = "Inter";
    static FONT_FAMILY_BOLD = "Inter-Bold";
    static TEXT_COLOR_DEFAULT = UIStyleConstants.GRAY_DARK_COLOR;
    static TEXT_COLOR_DISABLED = UIStyleConstants.GRAY_LIGHT_COLOR;
    static TEXT_COLOR_DARK_BLUE = UIStyleConstants.PRIMARY_COLOR;
    static TEXT_COLOR_BLUE = UIStyleConstants.PRIMARY_COLOR;
    static TEXT_COLOR_RED = UIStyleConstants.RED_COLOR;
    static TEXT_COLOR_GREEN = UIStyleConstants.GREEN_COLOR;

    static NO_COLOR = undefined;

    static lighten(hexColor: string, magnitude: number): string {
        return ColorUtilities.lighten(hexColor, magnitude);
    }
}

export const UIStyleConstantClasses = {
    titleTextLarge: {
        fontSize: "26px",
        fontFamily: UIStyleConstants.FONT_FAMILY,
        color: UIStyleConstants.BLUE_COLOR,
        fontWeight: "bolder",
    },
    titleText: {
        fontSize: "22px",
        fontFamily: UIStyleConstants.FONT_FAMILY,
        color: UIStyleConstants.BLUE_COLOR,
        fontWeight: "bolder",
    },
    sectionTitleText: {
        fontSize: "16px",
        fontWeight: 600,
        fontFamily: UIStyleConstants.FONT_FAMILY,
        letterSpacing: "0em",
        textAlign: "left",
        color: UIStyleConstants.BLUE_COLOR,
    },
    verySmallText: {
        fontSize: "10px",
        fontFamily: UIStyleConstants.FONT_FAMILY,
        color: UIStyleConstants.GRAY_DARK_COLOR,
        fontWeight: 500,
    },
    smallText: {
        fontSize: "12px",
        fontFamily: UIStyleConstants.FONT_FAMILY,
        color: UIStyleConstants.GRAY_DARK_COLOR,
        fontWeight: 500,
    },
    valueText: {
        fontSize: "14px",
        fontFamily: UIStyleConstants.FONT_FAMILY,
        color: UIStyleConstants.GRAY_DARK_COLOR,
        fontWeight: 700,
    },
    normalText: {
        fontSize: "14px",
        fontFamily: UIStyleConstants.FONT_FAMILY,
        color: UIStyleConstants.GRAY_DARK_COLOR,
        fontWeight: 500,
    },
    mediumText: {
        fontSize: "16px",
        fontFamily: UIStyleConstants.FONT_FAMILY,
        color: UIStyleConstants.GRAY_DARK_COLOR,
        fontWeight: 500,
    },
    largeText: {
        fontSize: "18px",
        fontFamily: UIStyleConstants.FONT_FAMILY,
        color: UIStyleConstants.GRAY_DARK_COLOR,
        fontWeight: 500,
    },
    pageRightButton: {
        background: UIStyleConstants.BLUE_COLOR,
        borderRadius: 4,
        color: UIStyleConstants.WHITE_COLOR,
        fontSize: 12,
        fontFamily: UIStyleConstants.FONT_FAMILY,
    },

    grayRow: {
        fontFamily: UIStyleConstants.FONT_FAMILY,
        background: UIStyleConstants.GRAY_VERY_LIGHT_COLOR,
    },
    orangeRow: {
        fontFamily: UIStyleConstants.FONT_FAMILY,
        background: UIStyleConstants.ORANGE_VERY_LIGHT_COLOR,
    },
    blueRow: {
        fontFamily: UIStyleConstants.FONT_FAMILY,
        background: UIStyleConstants.BLUE_VERY_LIGHT_COLOR,
    },
    greenRow: {
        fontFamily: UIStyleConstants.FONT_FAMILY,
        background: UIStyleConstants.GREEN_VERY_LIGHT_COLOR,
    },
    normalRow: {
        fontFamily: UIStyleConstants.FONT_FAMILY,
        background: UIStyleConstants.WHITE_COLOR,
    },
    columnText: {
        fontSize: "12px",
        lineHeight: 1.4,
        fontFamily: UIStyleConstants.FONT_FAMILY,
        color: UIStyleConstants.GRAY_DARK_COLOR,
        fontWeight: 500,
    },
    headerText: {
        fontSize: "12px",
        lineHeight: 1.4,
        fontFamily: UIStyleConstants.FONT_FAMILY,
        color: UIStyleConstants.GRAY_DARK_COLOR,
        fontWeight: 500,
        height: "37px",
    },

    gridStyling: {
        background: UIStyleConstants.GRAY_VERY_LIGHT_COLOR,
        padding: "16px !important",
        fontFamily: UIStyleConstants.FONT_FAMILY,
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "17px",
        letterSpacing: "0em",
    },
};
